import { useFormikContext } from 'formik';
import { useMemo } from 'react';

import { roundUp } from '@/services/global';
import { convertUnityToKg, returnQuantityComma } from '@/services/order';
import { ICartItemValues, ICartProduct } from '@/store/ducks/order/types';
import { IProduct } from '@/store/ducks/products/types';

interface Props {
  product: ICartProduct | IProduct;
}

function QuantityPreview({ product }: Props) {
  const { values } = useFormikContext<ICartItemValues>();

  const { options } = values;

  const optionsValid = options.filter((option) => option.add_order_quantity);
  const optionsValue = optionsValid.map((option) => {
    return option.select_options.reduce((acc, selectedOption) => {
      return roundUp(acc + (selectedOption.quantity ? parseFloat(selectedOption.quantity) : 0));
    }, 0);
  });

  const totalSelected = optionsValue.reduce((acc, value) => roundUp(acc + value), 0);
  const totalToString = totalSelected?.toString() ?? '0';

  const totalKG = useMemo(
    () => convertUnityToKg(totalToString, product),
    [totalSelected, product.ean],
  );

  return (
    <div className="d-flex flex-row quantity-preview py-2">
      <span className="title mr-2">Quant. total:</span>
      <div className="d-flex flex-column quantity-info rounded">
        {values.see_as_unit && (
          <span className="weigth-title px-2">
            Aprox {returnQuantityComma(+totalKG, product.measure)}
          </span>
        )}
        <span className="quantity rounded">
          {product.see_as_unit || product.measure === 'unity'
            ? totalSelected
            : returnQuantityComma(totalSelected, product.measure)}
        </span>
      </div>
    </div>
  );
}

export default QuantityPreview;
